export const metadata = {
	'scale_sqrt': 'Square √',
	'scale_pow': 'Pow ²',
	'scale_linear': 'Linear',
	'scale_log': 'Logarithmic',
}
export default metadata;